















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SummaryValuation extends Vue {
  @Prop() readonly doc!: any;
}
